import React from 'react';

import { get } from 'helpers/utilities';
import buildGTMData from 'helpers/buildGTMData';

import AboutUsHeader from 'components/AboutUsHeader';
import CareersJobList from 'components/CareersJobList';
import Contact from 'components/Contact';
import Meta from 'components/Meta';
import NavigationThemeSetter from 'components/NavigationThemeSetter';
import useContact from '../../hooks/useContact';
import useCareersContent from '../../hooks/useCareersContent';

const Careers = ({ transporterHeadRef, active }) => {
  const careersContent = useCareersContent();
  const contactData = useContact(careersContent);
  const gtmData = buildGTMData(careersContent);

  if (!careersContent || !contactData) return null;

  const headerData = get(careersContent, 'careersHeader[0]');
  const metaDetails = {
    metaSection: get(careersContent, 'socialMetaSection[0]'),
    entryTitle: get(careersContent, 'title'),
    placeholderImage: get(careersContent, 'careersHeader[0]headerBackground[0].url')
  };

  return (
    <>
      <Meta metaDetails={metaDetails} active={active} gtm={gtmData} />
      <NavigationThemeSetter navTheme="header" active={active}>
        <AboutUsHeader {...headerData} pageType="Careers" />
      </NavigationThemeSetter>
      <NavigationThemeSetter navTheme="white">
        <CareersJobList transporterHeadRef={transporterHeadRef} data={headerData} />
        <Contact {...contactData} />
      </NavigationThemeSetter>
    </>
  );
};

export default Careers;
